export default __webpack_public_path__ + "static/media/gallery03.f3c630b0.jpg";